import { render } from "./BarChart.vue?vue&type=template&id=2fef04c8&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=2fef04c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2fef04c8"

export default script